import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/nova-roots-way', label: 'Our Way' },
    { path: '/learning-model', label: 'Learning Model' },
    { path: '/living-curriculum', label: 'Living Curriculum' },
    { path: '/living-cultures', label: 'Living Cultures' },
    { path: '/walezi', label: 'Walezi' },
  ];

  const aboutLinks = [
    { path: '/environment', label: 'Environment' },
    { path: '/nairobi-pilot', label: 'Nairobi Pilot' },
    { path: '/faith-learning', label: 'Faith & Worldview' },
    { path: '/admissions', label: 'Admissions' },
    { path: '/fees', label: 'Fees' },
    { path: '/founder', label: 'Founder' },
  ];

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <img src="/nova-roots-logo-small.png" alt="Nova Roots" className="footer-logo-image" />
              <h3 className="footer-logo">Nova Roots</h3>
            </div>
            <p className="footer-tagline">
              A school built for how children actually learn.
            </p>
            <p className="footer-location">
              📍 Runda, Nairobi, Kenya
            </p>
            <p className="footer-launch">
              Opening September 2026
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Learning</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">About</h4>
            <ul className="footer-links">
              {aboutLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Get Started</h4>
            <p className="footer-text">
              Limited places available for our inaugural cohort.
            </p>
            <Link to="/contact" className="footer-cta">
              Register Your Interest
            </Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Nova Roots. All rights reserved.
          </p>
          <p className="footer-note">
            A new category of education in Kenya.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;